import type { ReactNode } from 'react'
import { Spin } from 'antd'
import ForbiddenPage from '@/components/feedback/ForbiddenPage'
import { useAuthStore } from '@/stores/authStore'

interface RequirePermissionProps {
  permission: string
  role?: string
  children: ReactNode
}

export default function RequirePermission({ permission, role, children }: RequirePermissionProps) {
  const authInitialized = useAuthStore((state) => state.authInitialized)
  const authLoading = useAuthStore((state) => state.authLoading)
  const hasPermission = useAuthStore((state) => state.hasPermission)
  const roles = useAuthStore((state) => state.roles)

  if (!authInitialized || authLoading) {
    return (
      <div style={{ minHeight: 200, display: 'grid', placeItems: 'center' }}>
        <Spin />
      </div>
    )
  }

  if (!hasPermission(permission)) {
    return <ForbiddenPage requiredPermission={permission} />
  }

  if (role && !roles.includes(role)) {
    return <ForbiddenPage requiredPermission={`role:${role}`} />
  }

  return <>{children}</>
}
